export default __webpack_public_path__ + "static/control-screenshot-9d8dff1c8ffe123d61189b3ce9775948.png";